import React, { FC } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Select,
  Col,
  Row,
  DatePicker,
} from "antd";
import firebase from "firebase/app";
import fire from "../../../../fire";
import { uuid } from "uuidv4";

interface IProps {
  parentCallback: (childData: boolean) => void;
}

const AddExpence: FC<IProps> = (props) => {
  const [form] = Form.useForm();
  const ref = fire.firestore().collection("Expenses");

  const createDoc = (newDataObj: any) => {
    ref
      .doc(newDataObj.id)
      .set(newDataObj)
      .catch((err) => {
        alert(err);
      });
  };

  const onFinish = (values: any) => {
    let timeStamp = firebase.firestore.FieldValue.serverTimestamp();
    values.cereatedOn = timeStamp;
    values.status = "Draft";
    values.id = `${uuid()}`;
    var tempDate = values.invoiceDate._d;
    let dd = tempDate.getDate();
    let mm = tempDate.getMonth() + 1;
    let yyyy = tempDate.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    let day = dd + "/" + mm + "/" + yyyy;
    values.invoiceDate = day;
    createDoc(values);
    props.parentCallback(false);
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        onFinish={onFinish}
      >
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label="Claim Type"
              name="claimType"
              rules={[
                {
                  required: true,
                  message: "Please Choose Claim Type",
                },
              ]}
            >
              <Select placeholder="Claim Type">
                <Select.Option value="Travel">Travel</Select.Option>
                <Select.Option value="Smartphone">Smartphone</Select.Option>
                <Select.Option value="Car">Car</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Type Of Visit"
              name="typeOfVisit"
              rules={[
                {
                  required: true,
                  message: "Please Choose Type Of Visit",
                },
              ]}
            >
              <Select placeholder="Type Of Visit">
                <Select.Option value="Client Meeting">
                  Client Meeting
                </Select.Option>
                <Select.Option value="x">x</Select.Option>
                <Select.Option value="y">y</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Client Name"
              name="clientName"
              rules={[
                {
                  required: true,
                  message: "Please Enter Client Name",
                },
              ]}
            >
              <Input placeholder="Cient Name" style={{ height: "31px" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label="Invoice Number"
              name="invoiceNumber"
              rules={[
                {
                  required: true,
                  message: "Please Enter Invoice Number",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Invoice Number"
                style={{ height: "31px" }}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Invoice Date"
              name="invoiceDate"
              rules={[
                {
                  required: true,
                  message: "Please Enter Invoice Date",
                },
              ]}
            >
              <DatePicker placeholder="From Date" style={{ width: "15rem" }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: "Please Enter Amount",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Amount"
                style={{ height: "2rem" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="remarks" label="Remarks">
          <Input.TextArea
            placeholder="Please Enter Remarks, if any"
            style={{ width: "782px", height: "89px" }}
          />
        </Form.Item>
        <Form.Item name="gst" valuePropName="checked">
          <Checkbox>GST Included</Checkbox>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default AddExpence;
